export const ASSESSMENT_ESCALATED_LABEL_VALUE = 3;